<template>
    <div class="row justify-content-center">
        <div class="col-lg-10 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center mb-4">
                        <h1>Registrate</h1>
                    </div>
                    <div class="text-center mt-3 mb-4">
                        <h4>Datos fiscales</h4>
                    </div>
                    <div class="row">
                        <div class="col-12 position-relative">
                            <base-input
                                v-model="model.f_razonsocial"
                                :label="model.f_extranjero ? 'Nombre de la empresa' : 'Razón Social'"
                                :placeholder="model.f_extranjero ? 'Nombre de la empresa': 'La Razón Social debe ser igual a la de tu Constancia Fiscal'"
                                inputClasses="input-group-alternative"
                                required
                                class="mb-2"
                            />
                            <base-checkbox
                                v-model="model.f_extranjero"
                                @input="checkExtranjero"
                                class="position-absolute"
                                style="top:0; right: 0; padding: inherit;"
                            >
                                Soy empresa extranjera
                            </base-checkbox>
                        </div>
                        
                        <div class="col-6">
                            <label class="form-control-label">
                                Régimen Fiscal 
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.f_regimenfiscal"
                                :options="regimenOptions || []"
                                :loading="!regimenOptions"
                                placeholder="Seleccionar Régimen Fiscal"
                                label="Name"
                                track-by="Code"
                                class="mb-2"
                                :show-labels="false"
                                :allow-empty="false"
                                :disabled="model.f_extranjero"
                            />
                        </div>

                        <div :class="model.f_extranjero ? 'col-3' : 'col-6'">
                            <base-input
                                inputClasses="input-group-alternative"
                                class="mb-0"
                                label="RFC"                                
                                placeholder="RFC (12 o 13 caracteres)"
                                v-model="model.f_rfc"
                                :disabled="model.f_extranjero"
                                required
                                maxlength="13"
                            />
                        </div>

                        <div class="col-3" v-if="model.f_extranjero">
                            <base-input
                                v-model="model.f_taxid"
                                label="Tax ID"
                                placeholder="Tax ID"
                                inputClasses="input-group-alternative"
                                required
                                class="mb-2"
                            />
                        </div>
                        <!-- <div class="col-12 px-3 mt-2" v-if="model.f_razonsocial && model.f_rfc && !model.f_extranjero && (model.f_rfc.length === 12 || model.f_rfc.length === 13)" >
                            <div v-if="rfc_validated" 
                                class="rounded text-green px-3 py-2 d-flex align-items-center" style="background: #dcfce7;">
                                <i class="fa fa-check-circle mr-3"></i>
                                <span class="text-xs font-weight-bold">Razón Social y RFC válidos</span>
                            </div>
                            <div v-else-if="!validatingRFC" class="rounded text-red px-3 py-2 d-flex align-items-center" style="background: #fee2e2;">
                                <i class="fa fa-exclamation-circle mr-3"></i>
                                <span class="text-xs font-weight-bold">{{rfc_message}}</span>
                            </div>
                            <div v-else class="rounded text-gray px-3 py-2 d-flex align-items-center" style="background: #f3f4f6;">
                                <i class="fa fa-info-circle mr-3"></i>
                                <span class="text-xs font-weight-bold">Validando..</span>
                            </div>
                        </div> -->
                        <hr class="col-12 my-3">
                        <div class="col-12">
							<h6 class="heading-small text-muted">Dirección de Facturación</h6>
                        </div>
                        <div class="col-6">
                            <base-input 
                                v-model="model.f_calle"
                                label="Calle"
                                inputClasses="input-group-alternative"
                                placeholder="Calle"
                                class="mb-2"
                                required
                            />
                        </div>

                        <div class="col-3">
                            <base-input 
                                v-model="model.f_noexterior"
                                label="No. Exterior"
                                inputClasses="input-group-alternative"
                                placeholder="No. Exterior"
                                required
                                class="mb-2"
                            />
                        </div>

                        <div class="col-sm-3">
                            <base-input 
                                v-model="model.f_nointerior"
                                label="No. Interior"
                                placeholder="No. Interior"
                                inputClasses="input-group-alternative"
                                class="mb-2"
                            />
                        </div>

                        <div class="col-3">
                            <base-input 
                                v-model="model.f_codigopostal"
                                inputClasses="input-group-alternative"
                                placeholder="Código Postal"
                                label="Código Postal"
                                maxlength="5"
                                @input="codigoPostalSelected(model.f_codigopostal, false)"
                                required
                                class="mb-2"
                            />
                        </div>

                        <div class="col-3" v-if="!model.f_extranjero">
                            <label class="form-control-label">
                                Colonia
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.f_colonia"
                                :options="colonias || []"
                                :loading="!colonias && model.f_codigopostal != null && model.f_codigopostal.length === 5 && !isNaN(model.f_codigopostal)"
                                :disabled="!model.f_codigopostal || model.f_codigopostal.length !== 5 || isNaN(model.f_codigopostal)"
                                placeholder="Colonia"
                                label="Name"
                                track-by="Value"
                                :showLabels="false"
                                class="mb-2"
                            />
                        </div>
                        <div v-if="model.f_colonia && model.f_colonia.Name === 'Otra'" class="col-sm-3">
                            <base-input 
                                v-model="model.f_otracolonia"
                                :placeholder="model.f_extranjero ? 'Colonia' : 'Otra Colonia'"
                                :label="model.f_extranjero ? 'Colonia' : 'Otra Colonia'"
                                inputClasses="input-group-alternative"
                                required
                                class="mb-2"
                            />
                        </div>

                        <div class="col-3" v-if="!model.f_extranjero">
                            <label class="form-control-label">
                                Estado
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.f_estado"
                                :options="states || []"
                                :loading="!states"
                                placeholder="Seleccionar Estado"
                                label="Name"
                                track-by="Value"
                                @select="stateSelectedBillTo"
                                :show-labels="false"
                                :allowEmpty="false"
                                class="mb-2"
                            />
                        </div>

                        <div class="col-sm-3" v-else>
                            <base-input 
                                v-model="model.f_estado"
                                inputClasses="input-group-alternative"
                                placeholder="Estado"
                                label="Estado"
                                class="mb-2"
                                required
                            />
                        </div>

                        <div class="col-3" v-if="!model.f_extranjero">
                            <label class="form-control-label">
                                Municipio
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.f_municipio"
                                :options="municipios || []"
                                :loading="!municipios && model.f_estado != null"
                                :disabled="!model.f_estado"
                                placeholder="Seleccionar Municipio"
                                label="Name"
                                track-by="Value"
                                :showLabels="false"
                                :allowEmpty="false"
                                class="mb-2"
                            />
                        </div>
                        <div class="col-sm-3" v-else>
                            <base-input 
                                v-model="model.f_municipio"
                                inputClasses="input-group-alternative"
                                placeholder="Municipio"
                                label="Municipio"
                                class="mb-2"
                                required
                            />
                        </div>

                        <div class="col-3" v-if="model.f_extranjero">
                            <base-input 
                                v-model="model.f_pais"
                                label="País"
                                inputClasses="input-group-alternative"
                                placeholder="País"
                                class="mb-2"
                                required
                            />
                        </div>
                        
                        <hr class="col-12 my-3">


                        <div class="col-4" >
                            <base-input 
                                v-model="model.f_telefono"
                                label="Teléfono (10 dígitos)"
                                inputClasses="input-group-alternative"
                                placeholder="Teléfono"
                                class="mb-2"
                                required
                                maxlength="10"
                            />
                        </div>
                        <div class="col-4">
                            <base-input 
                                v-model="model.f_email"
                                inputClasses="input-group-alternative"
                                label="Email"
                                placeholder="Email para envío de facturas"
                                type="email"
                                required
                                class="mb-2"
                            />
                        </div>
                        
                        <div class="col-sm-4">
                            <base-input 
                                v-model="model.f_paginaweb"
                                inputClasses="input-group-alternative"
                                placeholder="Página Web"
                                label="Página Web"
                                class="mb-2"
                            />
                        </div>


                        <hr class="col-12 my-3">

                        <div class="col-6">
                            <label class="form-control-label">
                                Uso CFDI
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.f_usocfdi"
                                :options="cfdiOptions"
                                label="name"
                                placeholder="Seleccionar Uso CFDI"
                                track-by="code"
                                :showLabels="false"
                                :allowEmpty="false"
                                class="mb-2"
                                :disabled="model.f_extranjero"
                            />
                        </div>
                        
                        <div class="col-3">
                            <label class="form-control-label">
                                Ramo
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.f_ramo"
                                :options="ramoOptions"
                                label="text"
                                placeholder="Seleccionar Ramo"
                                track-by="value"
                                :showLabels="false"
                                :allowEmpty="false"
                                class="mb-2"
                            />
                        </div>

                        <div class="col-3">
                            <label class="form-control-label">
                                Vendedor/a
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.f_vendedor"
                                :options="salesPersons || []"
                                :loading="!salesPersons"
                                placeholder="Quién te atendió"
                                label="SalesEmployeeName"
                                track-by="SalesEmployeeCode"
                                class="mb-2"
                                :show-labels="false"
                                :allow-empty="false"
                            />
                            
                        </div>
                        <div class="col-3">
                            <base-checkbox
                                v-model="model.f_enchapadora"
                                class="mb-4"
                                style="margin-top: 29px;"
                            >
                                Tengo enchapadora
                            </base-checkbox>
                        </div>

                        <div class="col-3">
                            <base-checkbox
                                v-model="model.f_pertenzecoGrupo"
                                class="mb-4"
                                style="margin-top: 29px;"
                            >
                                Pertenezco a un grupo comercial
                            </base-checkbox>
                        </div>

                        <div class="col-6">
                            <base-input 
                                v-if="model.f_pertenzecoGrupo"
                                v-model="model.f_grupoComercial"
                                inputClasses="input-group-alternative"
                                placeholder="¿A cuál grupo pertenece?"
                                label="Grupo Comercial"
                                class="mb-2"
                                required
                            />
                        </div>

                        <div class="col-12" v-if="!model.f_extranjero">
                            <label class="form-control-label">
                                Constancia Fiscal
                                <span class="text-red">*</span>    
                            </label>
                            <vue2-dropzone 
                                ref="dzConstFiscal"
                                id="dzConstFiscal"
                                @vdropzone-success="dzSuccess"
                                @vdropzone-max-files-exceeded="dzMaxFiles(files[0].dzId, $event)"
                                :options="files[0].dzOpt"
                                :useCustomSlot="true"
                                class="border-0 input-group-alternative rounded mb-2"
                                style="cursor: pointer;"
                            >
                                <div class="dropzone-custom-content">
                                    <h4 class="dropzone-custom-title">
                                        Arrastra y suelta el archivo de tu constancia fiscal aquí
                                    </h4>
                                    <small class="text-muted">
                                        ...o haz click para seleccionar el archivo desde tu computadora.
                                    </small>
                                </div>
                            </vue2-dropzone>
                        </div>

                        <hr class="col-12 my-3">
                        <div class="text-center mt-3 mb-4 col-12">
                            <h4>Dirección de entrega</h4>
                        </div>


                        <div class="col-12 position-relative">
                            <base-input 
                                v-model="model.fe_titulo"
                                inputClasses="input-group-alternative"
                                placeholder="Título"
                                label="Título"
                                disabled
                                required
                                class="mb-2"
                            />
                            <base-checkbox
                                v-model="f_mismaDireccion"
                                @input="duplicateAddress"
                                class="position-absolute"
                                style="top:0; right: 0; padding: inherit;"
                            >
                                Utilizar Dirección de Facturación
                            </base-checkbox>
                        </div>

                        <div class="col-6">
                            <base-input 
                                v-model="model.fe_calle"
                                inputClasses="input-group-alternative"
                                placeholder="Calle"
                                label="Calle"
                                required
                                class="mb-2"
                                :disabled="f_mismaDireccion"
                            />
                        </div>

                        <div class="col-3">
                            <base-input 
                                v-model="model.fe_noexterior"
                                label="No. Exterior"
                                inputClasses="input-group-alternative"
                                placeholder="No. Exterior"
                                required
                                class="mb-2"
                                :disabled="f_mismaDireccion"
                            />
                        </div>

                        <div class="col-sm-3">
                            <base-input 
                                v-model="model.fe_nointerior"
                                inputClasses="input-group-alternative"
                                placeholder="No. Interior"
                                label="No. Interior"
                                class="mb-2"
                                :disabled="f_mismaDireccion"
                            />
                        </div>

                        <div class="col-3">
                            <base-input 
                                v-model="model.fe_codigopostal"
                                label="Código Postal"
                                inputClasses="input-group-alternative"
                                placeholder="Código Postal"
                                maxlength="5"
                                @input="codigoPostalSelected(model.fe_codigopostal, true)"
                                required
                                class="mb-2"
                                :disabled="f_mismaDireccion"
                            />
                        </div>

                        <div class="col-3" v-if="!model.f_extranjero">
                            <label class="form-control-label">
                                Colonia
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.fe_colonia"
                                :options="colonias_shipTo || []"
                                placeholder="Seleccionar Colonia"
                                label="Name"
                                track-by="Value"
                                :show-labels="false"
                                :allow-empty="false"
                                :loading="!colonias_shipTo && model.fe_codigopostal != null && model.fe_codigopostal.length === 5 && !isNaN(model.fe_codigopostal)"
                                class="mb-2"
                                :disabled="f_mismaDireccion || !model.fe_codigopostal || model.fe_codigopostal.length !== 5 || isNaN(model.fe_codigopostal)"
                            />
                        </div>

                        <div class="col-3" v-if="model.fe_colonia && model.fe_colonia.Name === 'Otra'">
                            <base-input 
                                v-model="model.e_otracolonia"
                                :placeholder="model.f_extranjero ? 'Colonia' : 'Otra Colonia'"
                                :label="model.f_extranjero ? 'Colonia' : 'Otra Colonia'"
                                inputClasses="input-group-alternative"
                                required
                                class="mb-2"
                                :disabled="f_mismaDireccion"
                            />
                        </div>

                        <div class="col-3" v-if="!model.f_extranjero">
                            <label class="form-control-label">
                                Estado
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.fe_estado"
                                :options="states || []"
                                placeholder="Seleccionar Estado"
                                label="Name"
                                track-by="Value"
                                @select="stateSelected"
                                :show-labels="false"
                                :allow-empty="false"
                                class="mb-2"
                                :disabled="f_mismaDireccion"
                            />
                        </div>
                        <div class="col-sm-3" v-else>
                            <base-input 
                                v-model="model.fe_estado"
                                inputClasses="input-group-alternative"
                                placeholder="Estado"
                                label="Estado"
                                class="mb-2"
                                :disabled="f_mismaDireccion"
                                required
                            />
                        </div>


                        <div class="col-3" v-if="!model.f_extranjero">
                            <label class="form-control-label">
                                Municipio
                                <span class="text-red">*</span>    
                            </label>
                            <multiselect
                                v-model="model.fe_municipio"
                                :options="municipios_shipTo || []"
                                placeholder="Seleccionar Municipio"
                                label="Name"
                                track-by="Value"
                                :show-labels="false"
                                :allow-empty="false"
                                class="mb-2"
                                :disabled="f_mismaDireccion || !model.fe_estado"
                            />
                        </div>
                        <div class="col-sm-3" v-else>
                            <base-input 
                                v-model="model.fe_municipio"
                                inputClasses="input-group-alternative"
                                placeholder="Municipio"
                                label="Municipio"
                                class="mb-2"
                                :disabled="f_mismaDireccion"
                                required
                            />
                        </div>

                        <div class="col-3" v-if="model.f_extranjero">
                            <base-input 
                                v-model="model.fe_pais"
                                label="País"
                                inputClasses="input-group-alternative"
                                placeholder="País"
                                class="mb-2"
                                required
                                :disabled="f_mismaDireccion"
                            />
                        </div>

                        <hr class="col-12 my-3">

                        <div class="col-12 text-center mt-3 mb-4">
                            <h4>Datos de contacto</h4>
                        </div>

                        <div class="col-3">
                            <base-input 
                                v-model="model.fc_nombre"
                                inputClasses="input-group-alternative"
                                placeholder="Primer Nombre"
                                label="Primer Nombre"
                                required
                                class="mb-2"
                            />
                        </div>

                        <div class="col-3">
                            <base-input 
                                v-model="model.fc_nombre2"
                                inputClasses="input-group-alternative"
                                placeholder="Segundo Nombre"
                                label="Segundo Nombre"
                                class="mb-2"
                            />
                        </div>

                        <div class="col-6">
                            <base-input 
                                v-model="model.fc_apellidos"
                                inputClasses="input-group-alternative"
                                placeholder="Apellidos"
                                label="Apellidos"
                                required
                                class="mb-2"
                            />
                        </div>

                        <div class="col-6">
                            <base-input 
                                v-model="model.fc_puesto"
                                inputClasses="input-group-alternative"
                                placeholder="Puesto"
                                label="Puesto"
                                required
                                class="mb-2"
                            />
                        </div>
                        
                        <div class="col-6">
                            <base-input 
                                v-model="model.fc_email"
                                inputClasses="input-group-alternative"
                                placeholder="Email de contacto"
                                label="Email"
                                type="email"
                                required
                                class="mb-2"
                            />
                        </div>
                        <hr class="col-12 my-3">
                        <div v-if="!model.f_extranjero" class="col-12 d-flex flex-column align-items-center">
                            <div class="row">
                                <div class="text-center text-muted mb-1 mt-3 col-12">
                                    <h4 class="form-control-label">Número de celular
                                    <span class="text-red">*</span>
                                    </h4>
                                    <!-- <h5 class="text-gray font-weight-normal">Asegurate de poder recibir SMS, recibirás un código de confirmación</h5> -->
                                </div> 
                            </div>
                            <div class="d-flex align-items-center mb-2">
                                <div v-if="model.f_extranjero" >
                                    <base-input 
                                        v-model="model.f_codigotelefono"
                                        placeholder="Código de País"
                                        class="m-0 input-group-alternative mr-3"
                                        addon-left-icon="ni ni-fat-add"
                                        type="number"
                                        min="1"
                                        style="width: 170px;"
                                    />
                                </div>
                                <span class="mr-3 m-0 text-muted text-sm" v-else>
                                    <span v-if="model.f_extranjero && model.f_codigotelefono">
                                        + {{model.f_codigotelefono}}
                                    </span>
                                    <span v-if="!model.f_extranjero">+52</span>
                                </span>
                                <base-input 
                                    v-model="model.c_telefono"
                                    inputClasses="input-group-alternative"
                                    placeholder="Número de celular (10 dígitos)"
                                    maxlength="10"
                                    class="m-0"
                                    style="width: 230px;"
                                />
                            </div>

                            <!-- <div class="text-center mt-4" v-if="sentSMS">
                                <h5>Te hemos enviado un SMS con tu código de confirmación</h5>
                            </div> 
                            <base-input 
                                v-model="otp"
                                v-if="sentSMS"
                                class="input-group-alternative mb-3"
                                placeholder="Código SMS"
                                type="text"
                                addon-left-icon="ni ni-lock-circle-open"
                                style="width: 230px;"
                                maxlength="6"
                            >
                            </base-input>
                            <base-button 
                                outline 
                                size="sm" 
                                type="primary"  
                                v-if="sentSMS" 
                                @click="next"
                            >
                                Reenviar el código
                            </base-button> -->
                            <div id="recaptcha-container"></div>
                        </div>
                    </div>

                    <!-- <div v-if="!model.f_extranjero" class="d-flex flex-column align-items-center">
                        <div v-if="!sentSMS" tabindex="0" v-b-popover.hover.focus.html="popoverData" class="my-4 rounded-lg">
                            <base-button 
                                type="primary" 
                                @click="next" 
                                :disabled="!canRegister.valid"
                            >
                                Continuar
                            </base-button>
                        </div>
                        <base-button 
                            v-if="sentSMS" 
                            @click="verifyOtp"
                            type="primary" 
                            class="my-4"
                            v-b-popover.hover.focus.html="popoverData"
                            :disabled="!(otp && otp.length === 6) || !canRegister.valid"
                        >
                        Confirmar registro
                        </base-button>
                    </div> -->
                    <div class="d-flex flex-column align-items-center mt-4">
                        <div tabindex="0" v-b-popover.hover.focus.html="popoverData">
                            <base-button 
                                type="primary" 
                                @click="signInAnonymously" 
                                :disabled="!canRegister.valid"
                            >
                                Registrar
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 text-center">
                    <router-link to="/login" class="text text-white">
                        <small>¿Ya tienes cuenta?</small> <br>
                        <small>Inicia sesión aquí</small>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import firebase from "firebase/app";
    import "firebase/auth";
    import "firebase/firestore";
    import Multiselect from "vue-multiselect";
    import axios from 'axios';
    import vue2Dropzone from "vue2-dropzone";
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import regimenOptionsJSON from '../data/regimen_options.json'
    import cfdi from '@/data/cfdi.json'
    import ramo from '@/data/ramo.json'

  export default {
    name: 'register',
    components: {
        vue2Dropzone,
        Multiselect
    },
    data() {
        return {
            timeoutRazonSocial: null,
            timeoutRFC: null,
            BASE_URL: process.env.VUE_APP_BASE_URL,
            model: {
                f_taxid: null,
                f_razonsocial:null,
                f_regimenfiscal: null,
                f_rfc:'',
                f_extranjero: false,
                f_otracolonia: null,
                e_otracolonia: null,
                f_email: null,
                f_calle: null,
                f_noexterior: null,
                f_nointerior: null,
                f_codigopostal: null,
                f_municipio: null,
                f_colonia: null,
                f_pais: null,
                fe_titulo: 'Dirección de entrega',
                fe_calle: null,
                fe_noexterior: null,
                fe_nointerior: null,
                fe_codigopostal: null,
                fe_municipio: null,
                fe_colonia: null,
                fe_pais: null,
                f_telefono: null,
                f_paginaweb: null,
                fc_nombre: null,
                fc_nombre2: null,
                fc_apellidos: null,
                fc_puesto: null,
                fc_email: null,
                c_telefono: null,
                f_enchapadora: false,
                f_estado: null,
                fe_estado: null,
                f_usocfdi: null,
                f_ramo: null,
                f_vendedor: null,
                f_codigotelefono: null,
                f_const_fiscal_url: null,
                f_grupoComercial: null,
                f_pertenzecoGrupo: false,
            },
            f_mismaDireccion: false,
            rfc_validated: null,
            rfc_message: null,
            salesPersons: null,
            states: null,
            municipios: null,
            municipios_shipTo: null,
            colonias: null,
            colonias_shipTo: null,
            appVerifier : '',
            // otp : '',
            // sentSMS:false,
            regimenOptions: null,
            files:[
                { code: "const_fiscal", dzOpt: {}, link: null, dzId: "dzConstFiscal" }
            ],
            validatingRFC: false,
        }
    },
    mounted(){
        /**
         * * Obtain the options for the select of the Regimen Fiscal
         */
        axios
        .get(`/api/regimen_fiscal`)
        .then((result) => {
            if(result.data.msg){
                this.regimenOptions = regimenOptionsJSON
            } else {
                this.regimenOptions = result.data
            }
        })
        .catch((error) => {
            console.error(error);
        });
        
        fetch("https://uat.canplast.net/api/fa/states", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({country:"MEX"}),
        })
        .then((response) => response.json())
        .then((responseJson) => {
            this.states = responseJson.states
        })
        .catch((error) => {
            console.error(error);
        });
        fetch("https://api.lb.canplast.net/api/sales_persons", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
        .then((response) => response.json())
        .then((responseJson) => {
            this.salesPersons = responseJson.value.filter(x => x.SalesEmployeeCode != -1)
        })
        .catch((error) => {
            console.error(error);
        });
    },
    created(){
        this.cfdiOptions = cfdi;
        this.ramoOptions = ramo;
        this.initReCaptcha()
        this.files.forEach(x => {
            x.dzOpt = {
                url : `${this.BASE_URL}/api/business_partners/fiscal_file`,
                uploadMultiple: false,
                maxFiles: 1,
                autoProcessQueue: true,
                addRemoveLinks: true,
                acceptedFiles: "image/jpg,image/jpeg,image/png,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            };
        });
    },
    methods: {
        checkExtranjero(value){
            if(value){
                if(this.regimenOptions){
                    this.model.f_regimenfiscal = this.regimenOptions.find(x => x.Code === "616") || null;
                } else {
                    this.model.f_regimenfiscal = null;
                }
                this.model.f_rfc = "XEXX010101000";
                this.model.f_usocfdi = this.cfdiOptions.find(x => x.code === "S01") || null;
                this.model.f_colonia = { Name: 'Otra', Value: 'Otra' };
                this.model.f_estado = null;
                this.model.f_municipio = null;
                this.model.fe_colonia =  { Name: 'Otra', Value: 'Otra' };
                this.model.fe_estado = null;
                this.model.fe_municipio = null;
                this.model.f_const_fiscal_url = null;
                this.f_mismaDireccion = false;
                this.model.fe_titulo = 'Dirección de entrega';


            } else {
                this.model.f_regimenfiscal = null;
                this.model.f_rfc = null;
                this.model.f_taxid = null;
                this.model.f_usocfdi = null;

                this.model.f_codigopostal = null;
                this.model.f_colonia = null;
                this.model.f_otracolonia = null;
                this.model.f_estado = null;
                this.model.f_municipio = null;
                this.model.f_pais = null;
                this.colonias = null;
                this.municipios = null;

                this.model.fe_codigopostal = null;
                this.model.fe_colonia = null;
                this.model.e_otracolonia = null;
                this.model.fe_estado = null;
                this.model.fe_municipio = null;
                this.model.fe_pais = null;
                this.colonias_shipTo = null;
                this.municipios_shipTo = null;

                this.model.f_codigotelefono = null;
                this.f_mismaDireccion = false;
                this.model.fe_titulo = 'Dirección de entrega';
            }
        },
        validateRFC(){

                if(this.model.f_rfc && this.model.f_razonsocial && (this.model.f_rfc.length === 12 || this.model.f_rfc.length === 13) && !this.model.f_extranjero){
                    this.rfc_validated = false;
                    this.rfc_message = null;
                    const data = {
                        rfc: this.model.f_rfc
                    }
                    var url = `${this.BASE_URL}/api/business_partners/fiscal_file?rfc=${this.model.f_rfc}&file_type=`
    
                    this.files.forEach(x =>{
                        if(this.$refs[x.dzId]){
                            this.$refs[x.dzId].setOption('url', url + x.code);
                            this.$refs[x.dzId].setOption('headers', { "Authorization": axios.defaults.headers.common['Authorization'] });   
                        }
                    });

                    // axios.post(`https://uat.canplast.net/api/fpt/validateRFC`, {rfc:this.model.f_rfc, nombreRazonSocial:this.model.f_razonsocial.toUpperCase()})
                    // .then(res => {
                        // if(res.data.rfc && res.data.rfc.length > 0 && res.data.rfc[0].esValido === true){
                            this.rfc_validated = true
                        // } else if (res.data.rfc && res.data.rfc.length > 0){
                        //     this.rfc_validated = false
                        //     this.rfc_message = res.data.rfc[0].estatus
                        // }
                    // })
                    // .catch(err => {
                    //     console.error(err); 
                    // }).finally(() => {
                        this.validatingRFC = false
                    // });
                } else {
                    this.validatingRFC = false;
                }
        },
        codigoPostalSelected(data, shipTo){
            if(!this.model.f_extranjero){
                if(data.length === 5 && !isNaN(data)){
                    if(shipTo){
                        this.colonias_shipTo = null
                    } else {
                        this.colonias = null
                    }
    
                    fetch("https://uat.canplast.net/api/fa/neighborhoods", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({postal_code:data}),
                    })
                    .then((response) => response.json())
                    .then((responseJson) => {
                        if(shipTo){
                            this.colonias_shipTo = responseJson.neighborhoods
                            this.colonias_shipTo.push({Name:'Otra',Value:'Otra'})
                        }   
                        else{
                            this.colonias = responseJson.neighborhoods
                            this.colonias.push({Name:'Otra',Value:'Otra'})        
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                } else {
                    if(shipTo){
                        this.colonias_shipTo = null
                    } else {
                        this.colonias = null
                    }
                } 
            }
        },
        stateSelectedBillTo(data){
            this.municipios = null;
            fetch("https://uat.canplast.net/api/fa/municipalities", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({state:data.Value}),
            })
            .then((response) => response.json())
            .then((responseJson) => {
                this.municipios = responseJson.municipios
            })
            .catch((error) => {
                console.error(error);
            });
        },
        stateSelected(data){
            this.municipios_shipTo = null;
            fetch("https://uat.canplast.net/api/fa/municipalities", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({state:data.Value}),
            })
            .then((response) => response.json())
            .then((responseJson) => {
                this.municipios_shipTo = responseJson.municipios
            })
            .catch((error) => {
                console.error(error);
            });
        },
        duplicateAddress(){
            if(this.f_mismaDireccion){
                if(this.validBillTo.valid){
                    this.model.fe_titulo = 'Enviar a dirección fiscal'
                    this.model.fe_estado = this.model.f_estado;
                    this.model.fe_calle = this.model.f_calle;
                    this.model.fe_noexterior = this.model.f_noexterior;
                    this.model.fe_nointerior = this.model.f_nointerior;
                    this.model.fe_codigopostal = this.model.f_codigopostal;
                    this.model.fe_municipio = this.model.f_municipio;
                    this.model.fe_colonia = this.model.f_colonia;
                    this.model.e_otracolonia = this.model.f_otracolonia;
                    this.model.fe_pais = this.model.f_pais;
                    this.colonias_shipTo = this.colonias
                } else {
                    this.$swal(
                        'Dirección de Facturación Incompleta', 
                        'Por favor completa la dirección de facturación para poder utilizarla como dirección de entrega', 
                        'warning'
                    ).then(() => {
                        this.f_mismaDireccion = false;
                    });
                }
            } else {
                this.model.fe_titulo = 'Dirección de entrega'
                this.model.fe_estado = null;
                this.model.fe_calle = null;
                this.model.fe_noexterior = null;
                this.model.fe_nointerior = null;
                this.model.fe_codigopostal = null;
                this.model.fe_municipio = null;
                this.model.fe_colonia = null;
                this.model.e_otracolonia = null;
                this.model.fe_pais = null;
                this.colonias_shipTo = null
            }
        },
        signInAnonymously(){
            if(this.canRegister.valid){
                firebase.auth().signInAnonymously()
                .then(() => {
                    this.addInFirebase();
                })
                .catch((error) => {
                    console.error("Error", error)
                });
            } else {
                this.$swal('Error', "Por favor completa todos los campos", 'error');
            }
        },
        // next(){
        //     if(this.canRegister.valid){
        //         let countryCode = this.model.f_extranjero ? `+${this.model.f_codigotelefono}` : '+52' //Mexico
        //         let phoneNumber = countryCode + this.model.c_telefono
        //         let appVerifier = this.appVerifier
        //         //
        //         firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
        //         .then((confirmationResult) => {
        //             // SMS sent. Prompt user to type the code from the message, then sign the
        //             // user in with confirmationResult.confirm(code).
        //             window.confirmationResult = confirmationResult;
        //             this.sentSMS = true;
        //             this.$swal('Te estamos enviando un SMS con el código de verificación', '', 'info');
        //         }).catch((error) => {
        //             // Error; SMS not sent
        //             this.$swal(
        //                 `Verifica que tu código de país y número de celular sean correctos ${phoneNumber}` , 
        //                 error.message, 
        //                 'error'
        //             );
        //             console.error("Error", error)
        //         });
        //     }
        // },
        initReCaptcha(){
            setTimeout(()=>{
                window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
                'size': 'invisible',
                'callback': function(response) {
                    // reCAPTCHA solved, allow signInWithPhoneNumber.
                    // ...
                },
                'expired-callback': function() {
                    // Response expired. Ask user to solve reCAPTCHA again.
                    // ...
                }
                });
                //
                this.appVerifier =  window.recaptchaVerifier
            },1000)
        },
        addInFirebase(){
            const data = {
                // Datos Fiscales
                f_extranjero: this.model.f_extranjero,
                f_razonsocial: this.model.f_razonsocial,
                f_regimenfiscal: this.model.f_regimenfiscal,
                f_rfc: this.model.f_rfc,
                f_taxid: this.model.f_taxid,
                f_calle: this.model.f_calle,
                f_noexterior: this.model.f_noexterior,
                f_nointerior: this.model.f_nointerior,
                f_codigopostal: this.model.f_codigopostal,
                f_colonia: this.model.f_colonia.Name,
                f_otracolonia: this.model.f_otracolonia,
                f_estado: this.model.f_extranjero ? this.model.f_estado : this.model.f_estado.Value,
                f_municipio: this.model.f_extranjero ? this.model.f_municipio : this.model.f_municipio.Name,
                f_pais: this.model.f_pais,
                f_codigotelefono: this.model.f_codigotelefono,
                f_telefono: this.model.f_telefono,
                f_email: this.model.f_email,
                f_paginaweb: this.model.f_paginaweb,
                f_usocfdi: this.model.f_usocfdi.code,
                f_ramo: this.model.f_ramo.value,
                f_vendedor: this.model.f_vendedor.SalesEmployeeCode,
                f_enchapadora: this.model.f_enchapadora,
                f_pertenzecoGrupo: this.model.f_pertenzecoGrupo,
                f_grupoComercial: this.model.f_grupoComercial,
                f_const_fiscal_url: this.model.f_const_fiscal_url,
                f_moneda: 'Moneda',
                f_cedis: 'CEDIS',
                // Dirección de entrega
                fe_titulo: this.model.fe_titulo,
                fe_calle: this.model.fe_calle,
                fe_noexterior: this.model.fe_noexterior,
                fe_nointerior: this.model.fe_nointerior,
                fe_codigopostal: this.model.fe_codigopostal,
                fe_colonia: this.model.fe_colonia.Name,
                e_otracolonia: this.model.e_otracolonia,
                fe_estado: this.model.f_extranjero ? this.model.fe_estado : this.model.fe_estado.Value,
                fe_municipio: this.model.f_extranjero ? this.model.fe_municipio : this.model.fe_municipio.Name,
                fe_pais: this.model.fe_pais,
                // Datos de contacto
                fc_nombre: this.model.fc_nombre,
                fc_nombre2: this.model.fc_nombre2,
                fc_apellidos: this.model.fc_apellidos,
                fc_puesto: this.model.fc_puesto,
                fc_email: this.model.fc_email,
                // Numero de celular (SMS)
                c_telefono: this.model.c_telefono,
            }
            console.log("DATA",data)
            firebase
            .firestore()
            .collection("NuevosClientes")
            .add(data)
            .then((docRef) => {
                localStorage.setItem("rfc", this.model.f_rfc);
                localStorage.setItem("email", this.model.f_email);
                fetch("https://canplast.net:51000/api/sendEmail/nuevaAltaCliente/"+this.model.f_razonsocial, {
                    method: "GET",
                })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson)
                })
                .catch((error) => {
                    console.error(error);
                });
                this.$swal('Solicitud de registro enviada', "Tu registro se completó con éxito. El equipo de Canplast México revisará tu información y un agente de ventas se contactará contigo", 'success');
                this.$router.replace("inicio");
            })
            .catch(() => {
                this.$swal('Error', "Hubo un error al crear el usuario", 'error');
            });
        },
        // verifyOtp(){
        //     if(this.canRegister.valid && this.otp.length === 6){
        //         let code = this.otp
        //         window.confirmationResult.confirm(code).then((result) => {
        //             // User signed in successfully.
        //             this.addInFirebase();
        //         }).catch((error) => {
        //             console.error(error)
        //             if(error.code === 'auth/code-expired'){
        //                 this.$swal('Error', "El código de verificación ha expirado. Por favor reenvia el codigo de verificación de nuevo.", 'error');
        //             }
        //             else if(error.code === 'auth/invalid-verification-code'){
        //                 this.$swal('Error', "El código de verificación es invalido. Por favor revisa el código de verificación y vuelve a intentarlo.", 'error');
        //             }
        //             else{
        //                 this.$swal('Error', "Hubo un error con el código de verificación", 'error');
                        
        //             }
        //         });
        //     } else {
        //         this.$swal('Error', "Por favor completa todos los campos", 'error');
        //     }
        // },
        dzSuccess(file, response){
            // console.log("🚀 ~ file: Register.vue:1031 ~ dzSuccess ~ response:", response)
            // console.log("🚀 ~ file: Register.vue:1031 ~ dzSuccess ~ file:", file)
            this.files.every(x => {
            if(file.xhr.responseURL.includes(x.code)){
                x.link = response.firebase_url;
                this.model.f_const_fiscal_url = response.firebase_url;
                return false;
            } else {
                return true;
            }
            });
            this.reqNum ++;
            if(this.reqNum === 5){
                this.reqNum = 0;
            }
        },
        dzMaxFiles(dzId, file){
            this.$refs[dzId].removeFile(file);
            this.$swal("", "Solo puedes subir un archivo", "warning");
        },
    },

    computed:{
        canRegister(){
            const { 
                f_extranjero, f_razonsocial, f_regimenfiscal, f_rfc, f_taxid, f_telefono, f_email, f_usocfdi, f_ramo, f_vendedor, f_pertenzecoGrupo, f_grupoComercial, f_const_fiscal_url, fe_titulo, fe_calle, fe_noexterior, fe_codigopostal, fe_colonia, e_otracolonia, fe_estado, fe_municipio, fe_pais, fc_nombre, fc_apellidos, fc_puesto, fc_email, c_telefono
            } = this.model;

            const complete = {
                "Razón Social y RFC válidos en el SAT": f_razonsocial && f_rfc && (!f_extranjero ? this.rfc_validated : true),
                "Régimen Fiscal": f_regimenfiscal,
                "Tax ID": f_extranjero ? f_taxid : true,
                "Teléfono": f_telefono && f_telefono.length === 10,
                "Email para envío de facturas": f_email,
                "Uso CFDI": f_usocfdi,
                "Ramo": f_ramo,
                "Vendedor": f_vendedor,
                "Grupo Comercial": f_pertenzecoGrupo ? f_grupoComercial : true,
                "Constancia Fiscal": !f_extranjero ? f_const_fiscal_url : true,
                "Título (Dirección de entrega)": fe_titulo,
                "Calle (Dirección de entrega)": fe_calle,
                "Número Exterior (Dirección de entrega)": fe_noexterior,
                "Código Postal (Dirección de entrega)": fe_codigopostal,
                "Colonia (Dirección de entrega)": fe_colonia && (fe_colonia.Name === 'Otra' ? e_otracolonia : true),
                "Estado (Dirección de entrega)": fe_estado,
                "Municipio (Dirección de entrega)": fe_municipio,
                "País (Dirección de entrega)": f_extranjero ? fe_pais : true,
                "Nombre (Datos de contacto)": fc_nombre,
                "Apellidos (Datos de contacto)": fc_apellidos,
                "Puesto (Datos de contacto)": fc_puesto,
                "Correo electrónico (Datos de contacto)": fc_email,
                // "Código de País (ej. +1, +44...)": f_extranjero ? f_codigotelefono : true,
                "Número de celular para ingresar a la plataforma": !f_extranjero ? c_telefono && c_telefono.length === 10 : true
            }
            const valid = Object.values(complete).every(x => x);
            const missing = Object.keys(complete).filter(x => !complete[x]);
            return {
                valid: valid && this.validBillTo.valid,
                missing: missing.concat(this.validBillTo.missing)
            };
        },
        validBillTo(){
            const {f_calle, f_noexterior, f_codigopostal, f_colonia, f_otracolonia, f_estado, f_municipio, f_extranjero, f_pais} = this.model;
            const complete = {
                "Calle (Dirección de facturación)": f_calle,
                "Número Exterior (Dirección de facturación)": f_noexterior,
                "Código Postal (Dirección de facturación)": f_codigopostal,
                "Colonia (Dirección de facturación)": f_colonia && (f_colonia.Name === 'Otra' ? f_otracolonia : true),
                "Estado (Dirección de facturación)": f_estado,
                "Municipio (Dirección de facturación)": f_municipio,
                "País (Dirección de facturación)": f_extranjero ? f_pais : true
            }
            return {
                valid: Object.values(complete).every(x => x),
                missing: Object.keys(complete).filter(x => !complete[x])
            };
        },
        popoverData(){
            if(this.canRegister.missing.length > 0){
                return {
                    title: '<small><b>Falta completar los campos:</b></small>',
                    content:`<ul><li>${this.canRegister.missing.join('<li>')}</ul>` ,
                    placement: 'righttop',
                }
            } else {
                return null
            }
        },
        popoverRfcInvalid(){
            if(this.rfc_validated === false){
                return {
                    title: '<small><b>El RFC no es válido</b></small>',
                    content: this.rfc_message,
                    placement: 'righttop',
                }
            } else {
                return null
            }
        }
    },
    watch:{
        'model.f_rfc':{
            handler(newValue){
                this.validatingRFC = true;
                this.rfc_validated = false
                this.rfc_message = null;
                if(newValue){
                    this.model.f_rfc = newValue.replaceAll(" ","").toUpperCase()
                }
                clearTimeout(this.timeoutRFC);
                this.timeoutRFC = setTimeout(() => {
                    this.validateRFC();
                }, 300);
            },
            deep:true
        },
        'model.f_razonsocial': {
            handler(newValue){
                this.validatingRFC = true;
                this.rfc_validated = false
                this.rfc_message = null;
                if(newValue){
                    this.model.f_razonsocial = newValue.toUpperCase()
                }
                clearTimeout(this.timeoutRazonSocial);
                this.timeoutRazonSocial = setTimeout(() => {
                    this.validateRFC()
                }, 300);
            },
            deep:true
        
        }
    }
}
</script>
<style>
.popover{
    max-width: 800px !important;
}
</style>
